import React, { useEffect, useMemo, useState } from "react";
import { Box, Paper, Typography, Divider } from "@material-ui/core";
import BranchSelect from "../../Components/BranchSelect";
import DateRangeBar from "../../Components/DateRangeBar";
import ExportButtons from "../../Components/ExportButtons";
import DataTable from "../../Components/DataTable";
import { Api } from "../../api/client";
import { todayISO, daysAgoISO } from "./_date";

export default function IncidentesQuejas(){
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchId] = useState("");
  const [range, setRange] = useState({ from: daysAgoISO(30), to: todayISO() });
  const [rows, setRows] = useState([]);

  const params = useMemo(()=>({
    from: range.from, to: range.to, branch: branchId
  }), [range, branchId]);

  useEffect(()=>{
    Api.branches().then(res => setBranches(res.data))
      .catch(()=> setBranches([{id:"", nombre:"Todas"}]));
  }, []);

  useEffect(()=>{
    // TODO: Api.incidentes(params)
    setRows([]);
  }, [params]);

  const columns = [
    { key:"fecha", label:"Fecha" },
    { key:"pedido", label:"# Pedido" },
    { key:"tipo", label:"Tipo" },
    { key:"detalle", label:"Detalle" },
    { key:"estado", label:"Estado" },
    { key:"responsable", label:"Responsable" },
  ];

  return (
    <Paper style={{padding:18, borderRadius:14}}>
      <Typography variant="h6" style={{fontWeight:900}}>Incidentes / quejas</Typography>
      <Typography variant="body2" style={{opacity:.75, marginTop:6}}>
        (Pendiente de API) Retrasos, faltantes, mala atención, entrega incorrecta.
      </Typography>
      <Divider style={{margin:"12px 0"}}/>

      <Box display="flex" gridGap={12} flexWrap="wrap">
        <BranchSelect value={branchId} options={branches} onChange={setBranchId}/>
        <DateRangeBar from={range.from} to={range.to} onChange={setRange}/>
        <ExportButtons filename={`incidentes_${params.from}_a_${params.to}.csv`} rows={rows}/>
      </Box>

      <Box mt={2}>
        <DataTable columns={columns} rows={rows}/>
      </Box>
    </Paper>
  );
}